import cn from "@/v2-ui/utils/utils.cn"
import Page, { type PageProps } from "@/v2-backoffice-client/components/page"
// import SettingViewMode from "@/v2-backoffice-client/settings/SettingViewMode"
import SettingTheme from "@/v2-backoffice-client/settings/SettingTheme"
import SettingAppearance from "@/v2-backoffice-client/settings/SettingAppearance"
import SettingTable from "@/v2-backoffice-client/settings/SettingTable"
import SettingEditor from "@/v2-backoffice-client/settings/SettingEditor"

export type SettingPageProps = PageProps

function SettingPage(props: SettingPageProps) {
  const { className, ...pageProps } = props

  return (
    <Page className={cn(className)} {...pageProps}>
      <Page.Header>
        <Page.Title>Settings</Page.Title>
      </Page.Header>

      <Page.Content className="overflow-y-auto">
        {/* <SettingViewMode /> */}
        <SettingTheme />
        <SettingAppearance />
        <SettingTable />
        <SettingEditor />
      </Page.Content>
    </Page>
  )
}

export default SettingPage
